'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.monthsFromNow;


// WEBPACK FOOTER //
// ./~/sugar-date/number/monthsFromNow.js